module.exports = __webpack_public_path__ + "img/burger-ex-1.6e89d82b.svg";